import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({

  searchContainer: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  searchForm: {
    display: "flex",
    alignItems: "center",
  },

  searchFieldIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
  },

  searchButton: {
    marginLeft: theme.spacing(1.5),
    height: 56,
    minWidth: 110,
  },

  message: {
    marginTop: theme.spacing(1),
  },

  loading: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(5),
  },

  noResults: {
    padding: theme.spacing(3),
    textAlign: "center",
  },

  section: {
    marginBottom: theme.spacing(4),
  },

  sectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),

    "& svg": {
      color: theme.palette.text.secondary,
    }
  },

  resultCard: {
    height: "100%",
    padding: theme.spacing(2),
    cursor: "pointer",
    transition: "box-shadow 0.15s ease, transform 0.15s ease",

    "&:hover": {
      boxShadow: theme.shadows[4],
      transform: "translateY(-1px)",
    }
  },

  inactiveCard: {
    opacity: 0.55,
  },

  inactiveChip: {
    marginLeft: theme.spacing(1),
  },

  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: theme.spacing(1),
  },

  resultName: {
    fontWeight: 500,
  },

  customerName: {
    marginTop: 2,
  },

  detailLine: {
    marginTop: theme.spacing(0.75),
  },

  iconLine: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(0.75),
  },

  smallIcon: {
    fontSize: 17,
    marginRight: theme.spacing(0.75),
    color: theme.palette.text.secondary,
  },

  matchedText: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1.25),
    backgroundColor: theme.palette.background.default,
    borderLeft: `3px solid ${theme.palette.primary.main}`,
  },

  matchedLabel: {
    display: "block",
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },

  customerLink: {
    paddingLeft: 0,
    paddingRight: 0,
    textTransform: "none",
    fontWeight: 500,
  },

  highlight: {
    backgroundColor: "#fff3a3",
    color: "inherit",
    fontWeight: 600,
    paddingLeft: 1,
    paddingRight: 1,
    borderRadius: 2,
  },
  customerLinkText: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  stickySearchArea: {
    position: "fixed",
    top: 67,
    left: 258,
    right: 24,
    zIndex: 20,
    backgroundColor: "#f5f6fb",
    paddingTop: 8,
    paddingBottom: 8,

    [theme.breakpoints.down("sm")]: {
      left: 16,
      right: 16,
    },
  },

  fixedSearchSpacer: {
    height: 190,
  },
}));
